var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentCreator = function SvgContentCreator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.834 2.333a.833.833 0 0 0-.833.833v11.667a.833.833 0 0 0 .833.833h2.5a.833.833 0 1 1 0 1.667h-2.5a2.5 2.5 0 0 1-2.5-2.5V3.167a2.5 2.5 0 0 1 2.5-2.5h5.832c.221 0 .434.087.59.244l4.167 4.166a.833.833 0 0 1 .244.59V9a.833.833 0 0 1-1.666 0V6.5H9.5a1.667 1.667 0 0 1-1.667-1.667v-2.5H2.834Zm6.666 2.5V3.511l1.322 1.322H9.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.917 13.583.694-2.083h.695L12 13.583l2.083.695v.694L12 15.666l-.694 2.084h-.695l-.694-2.084-2.084-.694v-.694l2.084-.695Z"
  })));
};
export default SvgContentCreator;